import { render } from "./SectionDetail.vue?vue&type=template&id=641ab661&scoped=true&ts=true"
import script from "./SectionDetail.vue?vue&type=script&lang=ts"
export * from "./SectionDetail.vue?vue&type=script&lang=ts"

import "./SectionDetail.vue?vue&type=style&index=0&id=641ab661&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641ab661"]])

export default __exports__